import { BaseEdge } from 'reactflow';

// import styles from './EdgeTypes.module.scss';
import { Y_AXIS_SPACING } from '../hooks/react-flow-tree.const';
import { EdgeProps } from '../types';
import { Y_AXIS_SPACER as yAxisSpacer, BORDER_RADIUS as borderRadius } from '@/react_app/components/ReactFlow/EdgeTypes';
const getEdgePath = ({ sourceX, sourceY, targetX, targetY }: Pick<EdgeProps, 'sourceX' | 'sourceY' | 'targetY' | 'targetX'>) => {
	const middleY = (sourceY + targetY) / 2;
	return `M${sourceX - 50} ${sourceY + 82}
	Q ${sourceX - 50},${middleY} ${sourceX - 50},${middleY}
	L ${targetX + borderRadius},${middleY}
	Q ${targetX},${middleY} ${targetX},${middleY + borderRadius}
	L${targetX} ${targetY - yAxisSpacer}L${targetX} ${targetY}`;
};
export default function WorkflowLoopConnectorEdge({ id, sourceX, sourceY, targetX, targetY, markerStart, style }: EdgeProps) {
	const edgePath = getEdgePath({ sourceX, sourceY: sourceY - Y_AXIS_SPACING - 1, targetX, targetY });

	return <BaseEdge id={id} path={edgePath} style={style} markerStart={markerStart} />;
}
